export default __webpack_public_path__ + "static/media/PhoneIcon.b4faf27d.svg";